import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
    Burner,
    BurnDataVNext,
    MPSResultMpsDTO,
    MpsJobManagementOptions,
    MpsJobManagementResult,
    Queue,
    WorklistMpsSearchingParams
} from '../../../models/mps.models';
import { ServerRootService } from '../../../utils/routing/serverroot.service';


/** Il servizio MPSBaseService deve contenere tutte le chiamate ai metodi rest nel controller MPS!
 * Ogni metodo non deve avere logica ma solo effettuare la chiamata.
 * il tipo di ritorno deve essere sempre un Observable
 */
export abstract class MPSBaseService extends ServerRootService {
    protected readonly httpClient = inject(HttpClient);

    retrieveCompletedListEx(/*params: string*/params: WorklistMpsSearchingParams): Observable<Queue[]> {
        return this.httpClient.post<Queue[]>(
            this.getServerRoot() + '/MPS/RetrieveCompletedListEx',
            params,
            this.buildOptions(),
        );
    }

    retrieveQueueFilteredEx(/*params: string*/params: WorklistMpsSearchingParams): Observable<Queue[]> {
        return this.httpClient.post<Queue[]>(
            this.getServerRoot() + '/MPS/RetrieveQueueFilteredEx',
            params,
            this.buildOptions(),
        );
    }


    burnCd(burnData: BurnDataVNext): Observable<MPSResultMpsDTO> {
        return this.httpClient.post<MPSResultMpsDTO>(
            this.getServerRoot() + '/MPS/BurnCDVNext',
            burnData,
            this.buildOptions(),
        );
    }

    getBurners(clientName: string = ''): Observable<Burner[]>{
        return this.httpClient.get<Burner[]>(
            this.getServerRoot() + '/MPS/GetBurners?clientName=' + clientName,
            this.buildOptions(),
        );
    }

    modifyJob(mpsJobManagementOptions: MpsJobManagementOptions): Observable<MpsJobManagementResult[]> {
        return this.httpClient.post<MpsJobManagementResult[]>(this.getServerRoot() + '/MPS/ModifyJob',
            mpsJobManagementOptions,
            this.buildOptions());
    }
}
